export const version = {
  hash: '53ce2e10',
};
